/**
 * 手机号格式化
 * @param {String} phone
 */
const formatPhone = (phone) => {
  phone = phone.toString();
  return phone.substr(0, 3) + '****' + phone.substr(7, 11);
};

/**
 * 4位一空格（格式化银行卡）
 * @param {String} val
 */
const formatBank = (val) => {
  if (val) {
    return val.toString().replace(/\s/g, '').replace(/(.{4})/g, "$1 ");
  }
};

/**
 * 千分位格式化
 * @param {数字} val
 */
const toThousands = (val) => {
  let num = (val || 0).toString(),
    result = '';
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return result;
}

/**
 * 去除千分位
 * @param {数字字符串} val
 */
const delcommafy = (num) => {
　　if(num && num != 'undefined' && num != 'null'){
  　　　　let numS = num;
  　　　　numS = numS.toString();
  　　　　numS = numS.replace(/,/gi, '');
  　　　　return numS;
  　　}else {
  　　　　return num;
  　　}
}





/**
 * 格式化小数位
 * @param val 传入的值
 * @param pos 保留的小数位
 * @returns {*}
 */
const formatFloat = (val, pos = 2) => {
  let f = parseFloat(val);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(val * Math.pow(10, pos)) / Math.pow(10, pos); // pow 幂
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + pos) {
    s += '0';
  }
  return s;
}

/**
 * 格式化时长
 * @param second
 * @returns {string}
 */
const realFormatSecond = (second) => {
  let secondType = typeof second;

  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second);

    let hours = Math.floor(second / 3600);
    second = second - hours * 3600;
    let mimute = Math.floor(second / 60);
    second = second - mimute * 60;

    return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
  } else {
    return '0:00:00'
  }
};

const textSplit = (text,length) => {
  let textLength=length?length:25;
  return text.length>textLength?text.substring(0,textLength)+'...':text;
};
//检测图片地址中是否含有主域名
const checkDomain = (domain, url) => {
   if(url.indexOf(domain) >= 0) {
     return true;
   }
   return false;
};

//订单状态
const FilterOrderStatus = (orderStatus) => {
  let lang = JSON.parse(localStorage.getItem('lang'))
  let statusText = ''
  // let that = this;
  switch(orderStatus) {
      case -1:
        statusText = '草稿'
        break;
      case 1:
        statusText = lang==1?'待支付':(lang==2?'To be paid':'À payer')
        break;
      case 2:
        statusText = lang==1?'待审核':(lang==2?'Pending':'En attente')
        break;
      case 3:
        statusText = lang==1?'待发货':(lang==2?'Processing':'Préparation')
        break;
      case 4:
        statusText = lang==1?'已发货':(lang==2?'Shipped':'Expédiée')
        break;
      case 5:
        statusText = lang==1?'已完成':(lang==2?'Completed':'Livrée')
        break;
      case 6:
        statusText = lang==1?'已取消':(lang==2?'Cancelled':'Annulée')
        break;
      case 8:
        statusText = '退款中'
        break;
      case 10:
        statusText = lang==1?'异常状态订单':(lang==2?'Customer Service Orders':'Commandes via le Service Client')
        break;
      default:
  }
  return statusText;
}
//发票状态
const filterInvoiceStatus = (invoiceStatus) => {
  let statusText = ''
  switch(invoiceStatus) {
      case 1:
        statusText = '申请开票'
        break;
      case 2:
        statusText = '开票中'
        break;
      case 3:
        statusText = '查看发票'
        break;
      case -1:
        statusText = '不显示'
        break;
      case 4:
        statusText = '下载发票'
        break;
      default:
  }
  return statusText;
}

//配送方式
const filterCarryType = (carryTypeID) => {
  let statusText = ''
  switch(carryTypeID) {
      case 1:
        statusText = '赢盘普通配送'
        break;
      case 4:
        statusText = '第三方配送'
        break;
      case 6:
        statusText = ' 赢盘一小时配送'
        break;
      default:
  }
  return statusText;
}

// 本地存取数据
const setData = (name,data) =>{
  if(name == 'TempId'){
    return localStorage.setItem(name,data);
  }else{
    return localStorage.setItem(name,JSON.stringify(data));
  }
};
const readData = (name) =>{
  try{
    return JSON.parse(localStorage.getItem(name))
  }catch(e){
    return localStorage.getItem(name)
  }

}
// 生成全局唯一标识
const getUUID = () => {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export default {
  formatPhone,
  formatBank,
  toThousands,
  delcommafy,
  formatFloat,
  realFormatSecond,
  textSplit,
  setData,
  readData,
  checkDomain,
  getUUID,
  FilterOrderStatus,
  filterInvoiceStatus,
  filterCarryType
}



// WEBPACK FOOTER //
// ./src/plugins/filters.js